const groupsLogos = {
  'banco-itau': ['73', '70'],
  'banco-bradesco': ['80', '78', '61'],
  natura: ['75', '79'],
  'banco-santander': ['26', '53', '36', '134', '43', '28', '14'],
  'banco-caixa': ['64', '62'],
  marisa: ['91'],
  'banco-carrefour': ['98'],
  cielo: ['101'],
  'banco-agibank': ['95'],
  'banco-cetelem': ['30', '57', '89'],
  'banco-pan': ['138', '51', '45', '47'],
  'sorocred-afinz': ['58', '92'],
  'banco-digio': ['93'],
  riachuelo: ['149'],
  renner: ['152'],
}

const getDebtLogo = (walletId) => {
  for (const property in groupsLogos) {
    if (groupsLogos[property].includes(walletId)) {
      return property
    }
  }
  return 'recovery'
}

export default getDebtLogo
